import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 10px;
  max-width: 95px;
`;

const LogoHeader = ({ t }) => (
  <Wrapper>
    <img
      alt="logotype"
      src="https://cdn.selflystore.com/images-general/logos/selfly-logo.svg"
      className="se-logo "
    />
  </Wrapper>
);

export default LogoHeader;
